import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'insider-intl_marketing_page_brand_carousel_scroll-action_unknown';
/**
 * Insider Intl Marketing page brand carousel scroll event
 */
export function trackInsiderIntlMarketingPageBrandCarouselScroll() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
